import { render } from 'preact';

import { ApiCacheProvider, DataContext } from './habit-tracker/context';
import App from './habit-tracker/App';

const root = document.querySelector('[data-habit-tracker-portal]');
const dataElement =
  document.getElementById('habit-tracker-data') ||
  root.parentNode.querySelector('script[type="application/json"]');
const data = JSON.parse(dataElement.textContent);

root.innerHTML = ''; // remove the loading screen

render(
  <ApiCacheProvider>
    <DataContext.Provider value={data}>
      <App data={data} />
    </DataContext.Provider>
  </ApiCacheProvider>,
  root
);
